/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type RegisterBadgeUploadTokenMutationVariables = Types.Exact<{
  event_attendee_id: Types.Scalars["Int"];
  claim_id: Types.Scalars["Int"];
  badge_code: Types.Scalars["String"];
  badge_mac: Types.Scalars["String"];
  badge_secure_token_hash: Types.Scalars["String"];
}>;

export type RegisterBadgeUploadTokenMutation = Pick<
  Types.Mutation,
  "registerBadgeUploadToken"
>;

export const RegisterBadgeUploadTokenDocument = gql`
  mutation RegisterBadgeUploadToken(
    $event_attendee_id: Int!
    $claim_id: Int!
    $badge_code: String!
    $badge_mac: String!
    $badge_secure_token_hash: String!
  ) {
    registerBadgeUploadToken(
      event_attendee_id: $event_attendee_id
      claim_id: $claim_id
      badge_code: $badge_code
      badge_mac: $badge_mac
      badge_secure_token_hash: $badge_secure_token_hash
    )
  }
`;

/**
 * __useRegisterBadgeUploadTokenMutation__
 *
 * To run a mutation, you first call `useRegisterBadgeUploadTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterBadgeUploadTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerBadgeUploadTokenMutation, { data, loading, error }] = useRegisterBadgeUploadTokenMutation({
 *   variables: {
 *      event_attendee_id: // value for 'event_attendee_id'
 *      claim_id: // value for 'claim_id'
 *      badge_code: // value for 'badge_code'
 *      badge_mac: // value for 'badge_mac'
 *      badge_secure_token_hash: // value for 'badge_secure_token_hash'
 *   },
 * });
 */
export function useRegisterBadgeUploadTokenMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    RegisterBadgeUploadTokenMutation,
    RegisterBadgeUploadTokenMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    RegisterBadgeUploadTokenMutation,
    RegisterBadgeUploadTokenMutationVariables
  >(RegisterBadgeUploadTokenDocument, baseOptions);
}
export type RegisterBadgeUploadTokenMutationHookResult = ReturnType<
  typeof useRegisterBadgeUploadTokenMutation
>;
export type RegisterBadgeUploadTokenMutationResult =
  ApolloReactCommon.MutationResult<RegisterBadgeUploadTokenMutation>;
export type RegisterBadgeUploadTokenMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    RegisterBadgeUploadTokenMutation,
    RegisterBadgeUploadTokenMutationVariables
  >;
